import React from 'react';
import DetailDropDown from './detailDropDown/DetailDropDown';
import { DetailProps } from './detailDropDown/detail/Detail';

function NewsAndUpdates() {
  const details: Array<DetailProps> = [{ detail: 'Coming Soon!' }];

  return <DetailDropDown title="NEWS & UPDATES" details={details} />;
}

export default NewsAndUpdates;
